<template lang="pug">
    .container-restricao
        div(
            v-if='restricoes.length > 0',
            :class='restricoes[index].inibido ? "camada-inibida" : ""',
            v-for='(restricao, index) in listaRestricoes'
        )
            slot(name='botaoInibir', :restricao='restricoes[index]')
            .card-restricao
                .container-restricao-acoes(
                    v-if='existeDadosGeoEspaciais(restricoes[index])'
                )
                    div
                        el-button(
                            size='small',
                            icon='mdi mdi-crosshairs-gps',
                            @click='aplicarZoomRestricao(index)'
                        )
                p
                    b Id:
                    |
                    | {{ restricao.idTabela || '-' }}
                    br
                    b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.proprietario') }}:
                    |
                    | {{ restricao.proprietario || '-' }}
                    br
                    b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.cpfCnpj') }}:
                    |
                    | {{ numeralStringFormatTocpfCnpj(restricao.cpf_cnpj) }}
                    br
                    b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.fazenda') }}:
                    |
                    | {{ restricao.fazenda || '-' }}
                    br
                    b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.ano') }}:
                    |
                    | {{ restricao.ano || '-' }}
                    br
                    b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.municipio') }}:
                    |
                    | {{ restricao.municipio || '-' }}
                    br
                    b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.uf') }}:
                    |
                    | {{ restricao.uf || '-' }}
                    br
                    b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.latitude') }}:
                    |
                    | {{ restricao.latitude || '-' }}
                    br
                    b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.longitude') }}:
                    |
                    | {{ restricao.longitude || '-' }}
    </template>
    
    <script>
    import formatters from '@/utils/formatters';
    
    export default {
        name: 'controle-desmatamento-amazonia-pontos',
    
        data() {
            return {};
        },
    
        computed: {
            listaRestricoes: function () {
                return this.restricoes.map(value => {
                    if (value.properties) {
                        return {
                            ...value.properties
                        };
                    }
                    return value;
                });
            }
        },
    
        methods: {
            aplicarZoomRestricao(index) {
                let geometriaQueNaoEstavaDentroDasRestricoes = null;
                if (this.geometria) {
                    geometriaQueNaoEstavaDentroDasRestricoes =
                        this.geometria[index];
                }
                this.$emit(
                    'aplicar-zoom-restricao',
                    this.restricoes[index],
                    geometriaQueNaoEstavaDentroDasRestricoes,
                    index
                );
            },
            numeralStringFormatTocpfCnpj(cpfCnpj) {
                if (cpfCnpj) {
                    return formatters.numeralStringFormatTocpfCnpj(cpfCnpj);
                }
                return '-';
            },
            existeDadosGeoEspaciais(restricao) {
                const { geometry, geometria, properties } = restricao;
    
                if (properties?.latitude && properties?.longitude) {
                    return true;
                }
    
                return (
                    this.habilitarZoomRestricao &&
                    (geometry || geometria || this.geometria)
                );
            }
        },
    
        props: {
            restricoes: {
                type: Array,
                required: true
            },
            geometria: {
                type: Array,
                required: false,
                default: null
            },
            habilitarZoomRestricao: {
                type: Boolean,
                required: false,
                default: false
            }
        }
    };
    </script>
